<div *ngIf="refreshCoverageToggle">
  <app-dynamic-form *ngIf="refreshBasePlanToggle" [baseDOName]="configData.StateToDOMapper[transactionState]"
    (componentOutput)="basePlanComponentOutputHandler($event)"
    FORMTITLE="Base Plan" FORMNAME="BaseProductForm" [IO]="inputDataForEdit"
    [currentComponentName]="'BasePlanComponent'" [(ngModel)]="basePlanComponentData['BasePlanComponent']"
    [ExtractElementFromArray]="'true'" [maxDepth]="'4'"
    [formMetaData]="configData.ComponentMetaDataConfiguration.BasePlanComponent">
  </app-dynamic-form>

  <!-- <app-input-grid-nested *ngIf="refreshAdditionalCoveragesToggle"
    [componentMetaData]="configData.ComponentMetaDataConfiguration.MandatoryCoveragesComponent"
    [(ngModel)]="mandatoryCoverageComponentData['MandatoryCoveragesComponent']"
    (componentOutput)="mandatoryCoverageComponentHandler($event)" [transactionState]="transactionState"
    [currentComponent]="'MandatoryCoveragesComponent'" [IO]="payloadForMandatoryCoverages">
  </app-input-grid-nested>

  <app-input-grid-nested *ngIf="refreshAdditionalCoveragesToggle"
    [componentMetaData]="configData.ComponentMetaDataConfiguration.AdditionalCoveragesComponent"
    [(ngModel)]="additionalCoveragesComponentData['AdditionalCoveragesComponent']"
    (componentOutput)="additionalCoverageComponentHandler($event)" [transactionState]="transactionState"
    [currentComponent]="'AdditionalCoveragesComponent'" [IO]="payloadForAdditionalCoverages">
  </app-input-grid-nested> -->
  <div class="text-a-right m-t-b-15">
    <nz-radio-group [(ngModel)]="coverageView" [nzButtonStyle]="'solid'">
      <label nz-radio-button nzValue="panelView">Panel View</label>
      <label nz-radio-button nzValue="treeView">Tree View</label>
    </nz-radio-group>
  </div>
<div *ngIf="coverageView == 'treeView'">
  <div *ngIf="nodes.length > 0" class="config-grid m-t-30">
    <div class="treeSection" style="height: 500px;">
        <!-- <nz-tree [nzData]="nodes" nzAsyncData (nzExpandChange)="nzEvent($event)" (nzClick)="nzEvent($event)">
        </nz-tree> -->
        <nz-tree [nzData]="nodes" nzCheckable 
          [nzCheckedKeys]="chosenBenefitsList"
          [nzSelectedKeys]="selectedCoverageListForTree"
          [nzExpandedKeys]="expandChosenBenefitsList" 
          (nzExpandChange)="expandBenefit($event)" (nzCheckBoxChange)="checkBenefit($event)" (nzClick)="chooseBenefit($event)">
        </nz-tree>
    </div>
    <!-- <nz-skeleton  [nzAvatar]="false" [nzActive]="true" [nzTitle]="true" 
        [nzLoading]="!payloadInEdit"></nz-skeleton>-->
    <div ><!--*ngIf="payloadInEdit"-->
        <ng-container *ngTemplateOutlet="componentRenderer"></ng-container>
        <!-- <ng-container>
            <div class="card-summary-data-footer __data-footer-primary">
                <div style="width: 100%"></div>
                <div>
                    <button nz-button class="m-r-10" [nzType]="'primary'" (click)="saveHandler()">Save</button>
                </div>
            </div>
        </ng-container> -->
    </div>
</div>

<ng-template #componentRenderer>
  <!-- *ngIf="configData.ComponentMetaDataConfiguration.ICDSetup.Chapter.ChapterDetailsComponent.length>0  && 
              payloadInEdit && commonUtilty.isArrayIterable(payloadInEdit.chapters) && refreshComponentToggle" -->
  <ng-container *ngIf="mandatoryCoverageObjList && mandatoryCoverageObjList.length > 0" >
    <div *ngFor="let coverage of mandatoryCoverageObjList;let index = index;let first = first;" >
      <div [hidden]="!(coverage.riderCd == selectedCoverageFromTree)">
        <h3 class="heading">{{coverage.riderCd | technicalTranslate}}</h3>
        <app-dynamic-form *ngIf="coverage.uiConfigurations && coverage.uiConfigurations.length > 0" [baseDOName]="configData.StateToDOMapper[transactionState]"
              [FORMNAME]="'MandatoryCoverageForm' + index" [IO]="inputDataForEdit"
              [currentComponentName]="'MandatoryCoveragesComponent'" [(ngModel)]="mandatoryCoverageComponentData[index]"
              [ExtractElementFromArray]="'true'" 
              [formMetaData]="coverage.uiConfigurations" [lookupLoadingMode]="'byData'">
            </app-dynamic-form>
        </div>
    </div>
</ng-container>
  
  <ng-container *ngIf="additionalCoverageObjList && additionalCoverageObjList.length > 0" >
    <div *ngFor="let coverage of additionalCoverageObjList;let index = index;let first = first;">
      <div [hidden]="!(coverage.riderCd == selectedCoverageFromTree)">
        <h3 class="heading">{{coverage.riderCd | technicalTranslate}}</h3>
        <app-dynamic-form *ngIf="coverage.uiConfigurations && coverage.uiConfigurations.length > 0" [baseDOName]="configData.StateToDOMapper[transactionState]"
          [FORMNAME]="'AdditionalCoverageForm'+ index" [IO]="inputDataForEdit"
          [currentComponentName]="'AdditionalCoveragesComponent'" [(ngModel)]="additionalCoveragesComponentData[index]"
          [ExtractElementFromArray]="'true'"  [formMetaData]="coverage.uiConfigurations"
          [lookupLoadingMode]="'byData'">
        </app-dynamic-form>
      </div>
    </div>
  </ng-container>
  
  <div *ngIf="!selectedCoverageFromTree">
    <nz-alert
      nzType="info"
      nzMessage="Guide:"
      nzDescription="Please click on the coverage name from let-side tree to see the available configuration."
      nzShowIcon
    ></nz-alert>
  </div>

</ng-template>
</div>

<div *ngIf="coverageView == 'panelView'">
  <div>
    <nz-switch [ngModel]="true" nzCheckedChildren="Collapse All" nzUnCheckedChildren="Expand All" (ngModelChange)="expandCollapsePanel($event)"></nz-switch>
  </div>

  <div *ngIf="mandatoryCoverageObjList.length > 0" class="heading-tab panel-custom-unified-collapse-heading m-t-30 m-b-15">
    <h3 class="heading">
      <em nz-icon nzType="profile"></em> Mandatory Coverages
    </h3>
  </div>

  <nz-collapse *ngIf="mandatoryCoverageObjList.length > 0" class="m-t-20 coveragePanel">
    <nz-collapse-panel *ngFor="let coverage of mandatoryCoverageObjList;let index = index;let first = first;" 
      [nzHeader]="coverage.riderCd | technicalTranslate" [nzActive]="isExpand">
      <div>
        <div class="coveragePanelBody">
          <app-dynamic-form [baseDOName]="configData.StateToDOMapper[transactionState]"
            [FORMNAME]="'MandatoryCoverageForm' + index" [IO]="inputDataForEdit"
            [currentComponentName]="'MandatoryCoveragesComponent'" [(ngModel)]="mandatoryCoverageComponentData[index]"
            [ExtractElementFromArray]="'true'" [extractFromDOCoverage]="true"
            [formMetaData]="coverage.uiConfigurations" [lookupLoadingMode]="'byData'">
          </app-dynamic-form>
          
          <div style="height:200px; max-height:200px; overflow-y: auto;" *ngIf="coverage.productRiderBenefitList && coverage.productRiderBenefitList.length > 0">
            <h5 class="heading" style = "color:#1890ff;">Benefits available with {{coverage.riderCd | technicalTranslate}}: </h5>
            <nz-list [nzDataSource]="coverage.productRiderBenefitList" [nzRenderItem]="benefitItems" [nzItemLayout]="'horizontal'" nzBordered="true">
              <ng-template #benefitItems let-item>
                <nz-list-item>
                  <nz-list-item-meta
                    [nzTitle]="nzTitle"
                    [nzAvatar]="benefitIcons"
                    [nzDescription]="item.benefitDesc"
                  >
                    <ng-template #nzTitle>
                      <h4><i nz-icon nzType="plus-circle" nzTheme="outline"></i>  {{ item.benefitName }}</h4>
                    </ng-template>
                    <ng-template #benefitIcons>
                      <!-- <i nz-icon nzType="plus-circle" nzTheme="outline"></i> -->
                    </ng-template>
                  </nz-list-item-meta>
                </nz-list-item>
              </ng-template>
            </nz-list>
          </div>
        </div>
      </div>
    </nz-collapse-panel>
  </nz-collapse>

  <div *ngIf="additionalCoverageObjList.length > 0" class="heading-tab panel-custom-unified-collapse-heading m-t-30 m-b-15">
    <h3 class="heading">
      <em nz-icon nzType="profile"></em> Additional Coverages
    </h3>
  </div>
  <nz-collapse *ngIf="additionalCoverageObjList.length > 0" class="m-t-20 coveragePanel">
    <nz-collapse-panel *ngFor="let coverage of additionalCoverageObjList;let index = index;let first = first;" 
      [nzHeader]="coverage.riderCd | technicalTranslate" [nzActive]="isExpand"><!--[nzExtra]="selectCoverageTemplate"-->
      <div>
        <div class="coveragePanelBody">
          <app-dynamic-form [baseDOName]="configData.StateToDOMapper[transactionState]"
            [FORMNAME]="'AdditionalCoverageForm'+ index" [IO]="_inputDataForEdit"
            [currentComponentName]="'AdditionalCoveragesComponent'" [(ngModel)]="additionalCoveragesComponentData[index]"
            (ngModelChange)="setRider(coverage.riderCd, index)"
            [ExtractElementFromArray]="'true'" [extractFromDOCoverage]="true"
            [formMetaData]="coverage.uiConfigurations" [lookupLoadingMode]="'byData'">
          </app-dynamic-form>

          <div style="height:200px;max-height:200px; overflow-y: auto;" *ngIf="coverage.productRiderBenefitList && coverage.productRiderBenefitList.length > 0">
            <h5 class="heading" style = "color:#1890ff;">Benefits available with {{coverage.riderCd | technicalTranslate}}: </h5>
            <nz-list [nzDataSource]="coverage.productRiderBenefitList" [nzRenderItem]="benefitItems" [nzItemLayout]="'horizontal'" nzBordered="true">
              <ng-template #benefitItems let-item>
                <nz-list-item>
                  <nz-list-item-meta
                    [nzTitle]="nzTitle"
                    [nzAvatar]="nzAvatar"
                    [nzDescription]="item.benefitDesc"
                  >
                    <ng-template #nzTitle>
                      <h4><i nz-icon nzType="plus-circle" nzTheme="outline"></i>  {{ item.benefitName }}</h4>
                    </ng-template>
                    <ng-template #nzAvatar>
                      <!-- <i nz-icon nzType="plus-circle" nzTheme="outline"></i> -->
                    </ng-template>
                  </nz-list-item-meta>
                </nz-list-item>
              </ng-template>
            </nz-list>
          </div>

        </div>
      </div>
    </nz-collapse-panel>
  </nz-collapse>
  <ng-template #selectCoverageTemplate>
    <label nz-checkbox [(ngModel)]="chooseAdditionalCov"></label>
  </ng-template>
</div>
  <!-- <ng-template #deleteButtonTemplate>
    <em nz-icon nzType="delete" (click)="removeAdditionalCoverage($event)"></em>
  </ng-template> -->
  

</div>